export default __webpack_public_path__ + "static/media/messenger-stories.626aae5f.jpg";